import React, {Component} from 'react';
import {
  Table
}                         from 'react-bootstrap';
import moment             from 'moment';

class View extends Component {
  render() {
    let {
      selectedData
    } = this.props;

    const isUndefined = (obj) => typeof obj === 'undefined' ? true : false;

    return (
      <Table bordered responsive>
        <tbody>
          <tr>
            <td>USER</td>
            <td>{!isUndefined(selectedData.get('User')) && selectedData.get('User') !== null ? selectedData.get('User').get('name'): ''}</td>
          </tr>
          <tr>
            <td>MODULE</td>
            <td>{!isUndefined(selectedData.get('AccessListWeb')) ? selectedData.get('AccessListWeb').get('ModulesWeb').get('name') : ''}</td>
          </tr>
          <tr>
            <td>ACTION</td>
            <td>{!isUndefined(selectedData.get('AccessListWeb')) ? selectedData.get('AccessListWeb').get('Actions').get('name') : ''}</td>
          </tr>
          <tr>
            <td>PARAMETER</td>
            <td>{!isUndefined(selectedData.get('params')) ? selectedData.get('params') : ''}</td>
          </tr>
          <tr>
            <td>CLIENT IP</td>
            <td>{!isUndefined(selectedData.get('clientIp')) ? selectedData.get('clientIp') : ''}</td>
          </tr>
          <tr>
            <td>LOCAL IP</td>
            <td>{!isUndefined(selectedData.get('localIp')) ? selectedData.get('localIp') : ''}</td>
          </tr>
          <tr>
            <td>USER AGENT</td>
            <td>{!isUndefined(selectedData.get('userAgent')) ? selectedData.get('userAgent') : ''}</td>
          </tr>
          <tr>
            <td>DATE</td>
            <td>{!isUndefined(selectedData.get('createdAt')) ? moment(selectedData.get('createdAt')).format('MMMM Do YYYY, h:mm:ss a') : ''}</td>
          </tr>
        </tbody>
      </Table>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./components/AuditTrail/View.js